import React, { useContext } from "react";
import {
	Button,
	TextField,
	Paper,
	Typography,
	Alert,
	Container,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { login, SiteContext } from "gatsby-frontend";

const Form = styled(Paper)(({ theme }) => ({
	textAlign: "center",
	padding: theme.spacing(3),
	margin: theme.spacing(5, 0),
}));

function Login() {
	const { isAuthenticated, authContext, path } = useContext(SiteContext);
	const [submitting, setSubmitting] = React.useState(false);
	const [error, setError] = React.useState(null);

	/**
	 * handle automatic login if auth0
	 */
	const isAuth0 = !!process.env.GATSBY_IS_AUTH0;

	React.useEffect(() => {
		if (typeof window === "undefined") {
			return;
		}
		if (!isAuthenticated && isAuth0) {
			login(undefined, undefined, path);
		}
		return () => {};
	}, []);

	/**
	 * or handle regular username/password login
	 */
	return (
		<Container maxWidth="xs" sx={{ overflow: "hidden" }}>
			{isAuth0 ? (
				<Form elevation={3}>
					<Typography variant="h3">Redirecting to login...</Typography>
				</Form>
			) : (
				<Form
					component="form"
					elevation={3}
					onSubmit={async (e) => {
						e.preventDefault();
						setError(null);
						setSubmitting(true);
						let loggedIn = await login(e, authContext);
						if (!loggedIn) {
							setSubmitting(false);
							setError("Please check your username and password and try again");
						}
					}}
				>
					{error && <Alert severity="error">{error}</Alert>}
					<TextField
						fullWidth
						margin="normal"
						label="Email:"
						variant="outlined"
						name="username"
						disabled={submitting}
					/>
					<TextField
						fullWidth
						margin="normal"
						label="Password:"
						type="password"
						variant="outlined"
						name="password"
						disabled={submitting}
					/>
					<Button
						fullWidth
						type="submit"
						variant="contained"
						size="large"
						margin="normal"
						sx={{ marginTop: 2 }}
						disabled={submitting}
					>
						Login
					</Button>
				</Form>
			)}
		</Container>
	);
}

export default Login;
